
module.exports = function getResource(label, vars = []) {
    const resources = {
        shopFaves: 'Shop Your Favorites',
        viewAll: 'View all',
        fromLovesList: 'From your Loves list...'
    };
    return resources[label];
};
